import { Controller } from '@hotwired/stimulus';
import { fetchWithTurbo } from '../../modules/utils/fetchWithTurbo';

export default class extends Controller {
  static values = {
    baseUrl: String,
    queryParam: '/',
  }

  static targets = ['urlQueryId'];

  fetchWithTurboWithUrl (e) {
    let url = this.baseUrlValue;
    if (this.hasUrlQueryIdTarget) {
      if (this.urlQueryIdTarget.type === 'checkbox') {
        url += `${this.queryParamValue}${this.urlQueryIdTarget.checked}`;
      } else {
        url += `${this.queryParamValue}${e.target.value}`;
      }
    }
    fetchWithTurbo(url);
  }
}
